import { useIsUserInMooneLite } from "Hooks/useIsUserInMooneLite";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { UserStatus } from "Infrastructure/Api/Api";
import { Navigate } from "Navigation/Navigate";
import { getAppUrl } from "Utils/UrlUtils";
import type { PropsWithChildren } from "react";
import { useLocation } from "react-router";

type Props = PropsWithChildren<{
  isUserAuthenticated: boolean;
}>;

export const OnboardingRoute = ({ isUserAuthenticated, children }: Props) => {
  const { isLiteTier } = useIsUserInMooneLite();
  const location = useLocation();
  const user = useLoggedInUser();

  const appUrl = getAppUrl();

  if (!isUserAuthenticated) {
    return (
      <Navigate to={appUrl("sign-in")} state={{ from: location }} replace />
    );
  }

  // A not-yet-linked account has nothing to do in the legacy onboarding — every write there is
  // rejected until it migrates. Same gate as in AuthenticatedRoute.
  if (user?.migrationRequired) {
    return <Navigate to={appUrl("migration-required")} replace />;
  }

  // Only true Lite-tier users belong on the onboarding routes. Doc-expired users (Version=Full +
  // Status=Expired) already completed onboarding — sending them back here would be wrong.
  if (
    !isLiteTier &&
    user?.userStatus !== UserStatus.Onboarding &&
    user?.userStatus !== UserStatus.RoleSelection
  ) {
    return (
      <Navigate to={appUrl("dashboard")} state={{ from: location }} replace />
    );
  }

  return <>{children}</>;
};
